import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { Icon } from "../../components/Icon";
import { Markdown } from "../../components/Markdown/Markdown";
import { ShowMore } from "../../components/ShowMore";
import { primary25 } from "../../theme";
import { HeadingWithIcon } from "./HeadingWithIcon";

export const AiResponseAccordion = ({
  isPending,
  summary,
  summaryElement = <HeadingWithIcon title={summary} isPending={isPending} />,
  text,
  hideEmpty,
  markdown = false,
  showMoreMaxChars = 1500,
  expanded,
  onChange,
  defaultExpanded,
}) => {
  if (hideEmpty && !text) {
    return null;
  }

  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      expanded={expanded}
      onChange={onChange}
      sx={{
        bgcolor: primary25,
        mb: 1,
        boxShadow: "none",
        borderRadius: "6px",
        "&:before": {
          display: "none", // remove border
        },
      }}
    >
      <AccordionSummary
        expandIcon={<Icon name="ExpandMore" />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        {summaryElement}
      </AccordionSummary>
      <AccordionDetails
        sx={{
          opacity: isPending ? 0.5 : 1,
          transition: "opacity 0.1s ease-in-out",
        }}
      >
        {markdown ? (
          <Markdown text={text} />
        ) : showMoreMaxChars ? (
          <ShowMore maxChars={showMoreMaxChars} text={text} />
        ) : (
          text
        )}
      </AccordionDetails>
    </Accordion>
  );
};
